export default {
  en: {
    'components.registration-info-form.modify-confirmation.message':
      'Please note, by modifying this registration you will remove any existing Due Filing opportunities for this country.',

    'components.registration-info-form.date.invalid': 'Please enter a valid date',
    'components.registration-info-form.date.max-date-message':
      'Date should not be after maximal date',
    'components.registration-info-form.date.min-date-message':
      'Date should not be before minimal date',

    'components.registration-info-form.jurisdiction.label': 'Jurisdiction',
    'components.registration-info-form.jurisdiction.clear': 'Clear',
    'components.registration-info-form.jurisdiction.close': 'Close',
    'components.registration-info-form.jurisdiction.open': 'Open',
    'components.registration-info-form.jurisdiction.no-options': 'No matching jurisdictions',
    'components.registration-info-form.jurisdiction.required': 'Please select a jurisdiction',

    'components.registration-info-form.registration-type.label': 'Registration Type',
    'components.registration-info-form.registration-type.placeholder': 'Select Registration Type',
    'components.registration-info-form.registration-type.required':
      'Please select a Registration Type',

    'components.registration-info-form.vat-number.label': 'Registration Number',
    'components.registration-info-form.vat-number.placeholder': 'Enter Registration Number',
    'components.registration-info-form.vat-number.required': 'Please enter a Registration Number',

    'components.registration-info-form.local-vat-number.label': 'Local VAT Number',
    'components.registration-info-form.local-vat-number.placeholder': 'Enter Local VAT Number',
    'components.registration-info-form.local-vat-number.required':
      'Please enter a local VAT Number',

    'components.registration-info-form.registration-date.label': 'Registration Date',
    'components.registration-info-form.registration-date.required':
      'Please select a registration date',

    'components.registration-info-form.de-registration-date.label': 'De-registration Date',
    'components.registration-info-form.de-registration-date.required':
      'Please select a de-registration date',

    'components.registration-info-form.first-filing-data.label': 'First Filing Date',
    'components.registration-info-form.first-filing-data.required':
      'Please select a filing start date',
    'components.registration-info-form.first-filing-data.min':
      'Should not be before registration date',

    'components.registration-info-form.fiscale-code.label': 'Fiscale Code',
    'components.registration-info-form.fiscale-code.placeholder': 'Enter Fiscale Code',

    'components.registration-info-form.action.submit': 'Save',
    'components.registration-info-form.action.cancel': 'Cancel',
  },
};
